import { Avatar, Box, Paper, styled } from "@/components";

const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(1),
  right: theme.spacing(1),
  transition: theme.transitions.create(["transform", "opacity"], {
    duration: theme.transitions.duration.shorter,
  }),
  variants: [
    {
      props: ({ expand = "false" }) => !Boolean(expand.replace(/false/, "")),
      style: {
        transform: "translateY(20vh)",
        opacity: 0,
      },
    },
    {
      props: ({ expand = "false" }) => Boolean(expand.replace(/false/, "")),
      style: {
        transform: "translateY(0)",
        opacity: 1,
      },
    },
  ],
}));

const StyledInfo = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  cursor: "pointer",
}));

const StyledAvatar = styled(Avatar)({
  width: 67,
  height: 67,
  cursor: "pointer",
});

export { StyledBox, StyledInfo, StyledAvatar };
